<template lang="pug">
  .contenedor-interno(v-on-clickaway="close")
    .title
      span Area
    .search
      .control
        input.input(
          type="text",
          placeholder="Buscar areas...",
          v-model="filtro"
          @keyup.enter="selectFirst"
          @keyup.esc="close"
          ref="busqueda"
        )
    .data
      transition-group.contenedor-data(name="fade-smooth-two" tag="div")
        .item.fdc(
          v-for="(o, index) in listaFiltrada"
          :key="'area_lookup_'+index"
          @click="seleccionarClick(o)"
        )
            span {{ o.nombreArea | capitalize }}
            span.name {{ o.nombreGerencia }}
      .info-message(v-if="!isLoading && listaFiltrada.length === 0")
        span No se encontraron coincidencias
      loading.center-lookup(v-if="isLoading")

</template>

<script>
import { apiGet, notify } from '../../util/general'
export default {
  name: 'lookup_area',
  data () {
    return {
      filtro                 : '',
      isLoading              : false,
      lista                  : []
    }
  },
  computed: {
    listaFiltrada () {
      var vm = this
      if (vm.filtro) {
        return vm.lista.filter(function (o) {
          return o.nombreArea.toLowerCase().includes(vm.filtro.toLowerCase()) || o.nombreGerencia.toLowerCase().includes(vm.filtro.toLowerCase())
        })
      } else {
        return vm.lista
      }
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    this.$refs.busqueda.focus()
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading                = true
      apiGet(vm, '/area', {}, function (data) {
        vm.lista = data.lista
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    selectFirst () {
      if (this.listaFiltrada.length === 0) {
        this.$emit('close')
      } else {
        this.$emit('selected', this.listaFiltrada[0])
        this.$emit('close')
      }
    },
    seleccionarClick (o) {
      this.$emit('selected', o)
      this.$emit('close')
    },
    close () {
      this.$emit('close', this.listaFiltrada[0])
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .name
    font-size 12px
    color #666
  .contenedor-interno
    display flex
    flex-direction column

    .title
      margin 10px 5px 5px 5px
      font-size 17px
      border-bottom 1px solid #ccc
      padding-bottom 10px
      text-align center

    .search
      padding 5px 10px

    .data
      max-height: 180px;
      overflow-y: auto;
      .center-lookup
        display: flex;
        justify-content: center;
      .contenedor-box
        >*
          transition all .5s
          width 100%
      padding 10px
      .item
        background: #fff;
        border-radius: 3px;
        border: 1px solid #d6dadc;
        border-bottom-color: #c4c9cc;
        -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
        box-shadow: 0 1px 6px rgba(0,0,0,.15);
        display flex
        padding 10px
        margin-bottom 5px
        cursor pointer
        transition all .2s ease

        &:hover
          background-color: #edeff0;
          margin-left: 4px;
          -webkit-box-shadow: -8px 0 #959da17d;
          box-shadow: -8px 0 #959da17d;
</style>



// WEBPACK FOOTER //
// Area.vue?f04c829a